import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsDefined, ValidateNested } from 'class-validator';
import { DefaultStoreExposeGroup, SpecialDayTypeEnum } from '../interface';
import { ReadAbstractDefaultStoreScheduleHoursRangeDto } from './ReadAbstractDefaultStoreScheduleHoursRangeDto';
import { ReadAbstractDefaultStoreSpecialDayDto } from './ReadAbstractDefaultStoreSpecialDayDto';
export class ReadDefaultStoreShortSpecialDayDto extends ReadAbstractDefaultStoreSpecialDayDto {
}
__decorate([
    ApiProperty({ type: () => SpecialDayTypeEnum.SHORT_DAY }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsDefined({ groups: [DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadDefaultStoreShortSpecialDayDto.prototype, "type", void 0);
__decorate([
    ApiProperty({ type: () => ReadAbstractDefaultStoreScheduleHoursRangeDto, isArray: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsDefined({ groups: [DefaultStoreExposeGroup.PATCH] }),
    ValidateNested({ each: true, groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Type(() => ReadAbstractDefaultStoreScheduleHoursRangeDto),
    __metadata("design:type", Array)
], ReadDefaultStoreShortSpecialDayDto.prototype, "schedule", void 0);
//# sourceMappingURL=ReadDefaultStoreShortSpecialDayDto.js.map